import axios from 'axios';

const TICKLER_API_BASE_URL = 'https://ticklerapi.makebettinggreat.com/v1/';
const RPM_API_BASE_URL= "https://rpmapi.makebettinggreat.com/v1/";
const ENDPOINT_JOCKEY = TICKLER_API_BASE_URL + 'jockey/';
const ENDPOINT_ODDS = RPM_API_BASE_URL + 'horse/odds/';
const ENDPOINT_ODDS_TICKLER = TICKLER_API_BASE_URL + 'horse/odds/';
const ENDPOINT_MATCH = "";
const API_WINNER = 'https://rpmapi.makebettinggreat.com/v1/horse/winners/';

const API_SUCCESS_CODE = "0000"

export const getJockeyByDate = async (date, tab) => {
    const url = TICKLER_API_BASE_URL + tab.urlPath + date
    const result = await axios.get(url)
    const data = result.data
    if(result.status === 200) {
        return data;
    }else {
        return []
    }
}
function formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;
    return [year, month, day].join('');
}



export const getRunnerOddsByMarketId = async (marketId, selectionId, date) => {
    let endpoint = formatDate(new Date()) === date ? ENDPOINT_ODDS : ENDPOINT_ODDS_TICKLER;
    const url = endpoint + marketId + "/" + selectionId;
    const result = await axios.get(url)
    const data = result.data
    if(result.status === 200) {
        return data;
    }else {
        return []
    }
}

export const getWinnerInfo = async (marketId, date) => {
    const endpoint = API_WINNER + date + "/" + marketId
    const result = await axios.get(endpoint)
    const data = result.data
    if(result.status === 200) {
        return data;
    }else {
        return []
    }
}

// export const getLeaguesByDateCallback = (date, callback) => {
//     const url = ENDPOINT_LEAGUE + date
//     const result = axios.get(url).then(
//         result => {
//             callback(result.data.response)
//         }
//     )
// }

export const getMatchesByDate = async date => {
    const url = ENDPOINT_MATCH + date
    const result = await axios.get(url)
    const data = result.data
    if(data.status.returnCode === API_SUCCESS_CODE) {
        return data.response
    }else {
        return []
    }
}